import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';
import { Button } from '@tcc/crate';

import CheckboxRadio from 'common/CheckboxRadio';
import PopoverTrigger from 'triggers/PopoverTrigger';
import OverlayQuickSelectMenuContainer from 'mapping/OverlayQuickSelectMenuContainer';

const baseString = 'vra-overlay-select-trigger';
const OverlaySelectTrigger = ({
  isActive,
  isQuickSelectActive,
  onToggleShowOverlay,
  onToggleShowOverlayQuickSelect,
  overlayTitle
}) => {

  const openQuickSelectText = getMessage(
    isQuickSelectActive
      ? 'link-text__change-map--changing'
      : 'link-text__change-map'
  );
  const classString = classNames({
    'layer-select-button__link': true,
    'layer-select-button__link--button': true
  });
  const trigger = (
    <Button mode='link' onClick={ ()=> { onToggleShowOverlayQuickSelect(!isQuickSelectActive); } } testId='change-map' >
      {openQuickSelectText}
    </Button>
  );

  return (
    <section className='layer-select-button__container'>
      <CheckboxRadio
        isChecked={isActive}
        labelText={overlayTitle}
        name={baseString}
        onChange={() => onToggleShowOverlay(!isActive)}
        type='checkbox'
      />
      <PopoverTrigger
        className={classString}
        popoverContent={<OverlayQuickSelectMenuContainer/>}
        popoverIsOpen={isQuickSelectActive}
        popoverName='overlay-quick-select'
        popoverPlacement='top'
        trigger={trigger}
      />
    </section>
  );
};
OverlaySelectTrigger.propTypes = {
  isActive: propTypes.bool.isRequired,
  isQuickSelectActive: propTypes.bool.isRequired,
  onToggleShowOverlay: propTypes.func.isRequired,
  onToggleShowOverlayQuickSelect: propTypes.func.isRequired,
  overlayTitle: propTypes.string.isRequired
};

export default OverlaySelectTrigger;
